import React from "react";

const Spinner = () => (
    <div className="spinner">
        <i className="icon-spinner icon-3x" />
    </div>
);

export function getComponentByName(externalComponentModuleName: string) {
    let LazyComponent: any;
    switch (externalComponentModuleName) {
        case "oc_ui/SideCaddy":
            LazyComponent = React.lazy(() => import("oc_ui/SideCaddy"));
            break;
        case "oc_ui/MiniCartSelector":
            LazyComponent = React.lazy(() => import("oc_ui/MiniCartSelector"));
            break;
        case "oc_ui/SavedCartsList":
            LazyComponent = React.lazy(() => import("oc_ui/SavedCartsList"));
            break;

        case "cia_ui/Banner":
            LazyComponent = React.lazy(() => import("cia_ui/Banner"));
            break;
        case "cia_ui/StoreListItem":
            LazyComponent = React.lazy(() => import("cia_ui/StoreListItem"));
            break;
        case "cia_ui/StoreListTilesRow":
            LazyComponent = React.lazy(() => import("cia_ui/StoreListTilesRow"));
            break;
        case "cia_ui/Recommendations":
            LazyComponent = React.lazy(() => import("cia_ui/Recommendations"));
            break;
        case "cia_ui/IdamCompatibleLogoutLink":
            LazyComponent = React.lazy(() => import("cia_ui/IdamCompatibleLogoutLink"));
            break;
        case "cia_ui/LoginPrompt":
            LazyComponent = React.lazy(() => import("cia_ui/LoginPrompt"));
            break;

        case "sd_articlesearch_ui/GlobalHeader":
            LazyComponent = React.lazy(() => import("sd_articlesearch_ui/GlobalHeader"));
            break;
        case "sd_articlesearch_ui/AvailabilityDetails":
            LazyComponent = React.lazy(() => import("sd_articlesearch_ui/AvailabilityDetails"));
            break;

        case "sd_pdp_ui/BulkDiscountTiersDisplay":
            LazyComponent = React.lazy(() => import("sd_pdp_ui/BulkDiscountTiersDisplay"));
            break;
        case "sd_pdp_ui/BulkDiscountLabel":
            LazyComponent = React.lazy(() => import("sd_pdp_ui/BulkDiscountLabel"));
            break;
        case "sd_pdp_ui/AlternativesButtonWithModal":
            LazyComponent = React.lazy(() => import("sd_pdp_ui/AlternativesButtonWithModal"));
            break;
        default:
            LazyComponent = <>Shared Component ${externalComponentModuleName} does not exist in sd-ui/shared!</>;
    }

    const componentWrapper = (props: any) => (
        <React.Suspense fallback={<Spinner />}>
            <LazyComponent {...props} />
        </React.Suspense>
    );

    const slashIndex = externalComponentModuleName.lastIndexOf("/");
    if (slashIndex === -1) {
        componentWrapper.displayName = externalComponentModuleName;
    } else {
        componentWrapper.displayName = externalComponentModuleName.substring(slashIndex + 1);
    }

    return componentWrapper;
}
